import React from "react";

const Dashboard = () => {

  const stats = [
    {
      title: "Total Users",
      value: "12,450",
      subtitle: "Registered Users",
      color: "danger",
    },
    {
      title: "This Month Users",
      value: "845",
      subtitle: "New Registrations",
      color: "primary",
    },
    {
      title: "Total Plans Purchased",
      value: "8,920",
      subtitle: "All Time Purchases",
      color: "success",
    },
    {
      title: "This Month Plans",
      value: "620",
      subtitle: "Purchased This Month",
      color: "info",
    },
    {
      title: "Pending Commission",
      value: "₹ 45,850",
      subtitle: "Awaiting Payment",
      color: "warning",
    },
    {
      title: "Referral Clients",
      value: "2,340",
      subtitle: "Joined Through Referral",
      color: "secondary",
    },
    {
      title: "Pending Channel Requests",
      value: "36",
      subtitle: "Approval Required",
      color: "dark",
    },
  ];


  return (
    <>
      <section className="my-4">
        <div className="px-4">

          <p className="page-heading">
            Admin Dashboard
          </p>

          <p className="para-text text-muted">
            Monitor users, subscriptions, commissions and channel activities.
          </p>


          <div className="row mt-4">

            {stats.map((item, index) => (
              <div 
                className="col-lg-3 col-md-6 col-12 my-2"
                key={index}
              >

                <div className="subs-card h-100">

                  <p className="fs-3 mb-2">
                    <span className="subs-num">
                      {item.value}
                    </span>
                  </p>


                  <p 
                    className={`mb-0 fw-semibold text-${item.color}`}
                  >
                    {item.title}
                  </p>


                  <span className="para-text text-muted fw-semibold">
                    {item.subtitle}
                  </span>

                </div>

              </div>
            ))}

          </div>


          {/* Quick Activity Section */}

          <div className="row mt-4">

            <div className="col-lg-6 col-12 my-2">

              <div className="subs-card">

                <p className="fw-semibold fs-5">
                  Recent Activities
                </p>


                <div className="para-text text-muted">
                  <p>
                    ✓ 25 new users registered today
                  </p>

                  <p>
                    ✓ 15 premium plans purchased
                  </p>

                  <p>
                    ✓ 5 channel requests waiting approval
                  </p>

                  <p>
                    ✓ ₹12,500 commission pending payout
                  </p>

                </div>

              </div>

            </div>


            <div className="col-lg-6 col-12 my-2">

              <div className="subs-card">

                <p className="fw-semibold fs-5">
                  Subscription Overview
                </p>


                <div className="d-flex justify-content-between mb-2">
                  <span className="para-text">
                    Active Plans
                  </span>
                  <b>7,850</b>
                </div>


                <div className="d-flex justify-content-between mb-2">
                  <span className="para-text">
                    Expired Plans
                  </span>
                  <b>1,070</b>
                </div>


                <div className="d-flex justify-content-between">
                  <span className="para-text">
                    Revenue Generated
                  </span>
                  <b>₹24,50,000</b>
                </div>


              </div>

            </div>

          </div>


        </div>
      </section>
    </>
  );
};

export default Dashboard;